'use client';

import { useSyncExternalStore } from 'react';
import {
  bvUsZipPlansGetServerSnapshot,
  bvUsZipPlansGetSnapshot,
  bvUsZipPlansSubscribe,
} from 'utils/bvUsZipPlansStore';
import type { BvUsZipPlansSnapshot } from 'utils/bvUsZipPlansStore';

export function useBvUsZipPlansSnapshot(): BvUsZipPlansSnapshot {
  return useSyncExternalStore(
    bvUsZipPlansSubscribe,
    bvUsZipPlansGetSnapshot,
    bvUsZipPlansGetServerSnapshot,
  );
}

export const useBvUsZipPlansOptional = useBvUsZipPlansSnapshot;

export type { BvUsZipPlansSnapshot } from 'utils/bvUsZipPlansStore';
